import { useNavigate, useLocation,useSearchParams } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { useState } from "react";



const Sidebar = ({ sections }) => {
  const navigate = useNavigate();

  const [headerSelected, setHeaderSelected] = useState(
    [
      [false],
      [false,false,false],
      [false,false,false,false,false,false,false,false,false,false],
      [false,false,false],
      [false,false,false]
    ]
  )

  const[hideHeaders , setHideHeader] = useState([true,true,true,true,true])


  const handleSubHeaderSelection = (parentIndex, childIndex) => {
    const newHeader = headerSelected.map((subHeaders, pIdx) => {
      if (pIdx === parentIndex) {
        // Only the clicked subheader is true
        return subHeaders.map((_, cIdx) => cIdx === childIndex);
      }
      // Reset all other parents to all false
      return subHeaders.map(() => false);
    });
  
    setHeaderSelected(newHeader);
  };

    const handleScroll = (id, childIndex, parentIndex) => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        handleSubHeaderSelection(parentIndex, childIndex)
      }
    };

    const handleScrollParent = (id,index) => {
      
      const tempHideHeader = [...hideHeaders];
      tempHideHeader[index] = !tempHideHeader[index];
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        handleSubHeaderSelection(index, 0)

      }

      setHideHeader(tempHideHeader);
    };


  const handleLogout = () => {
    navigate("/login?fromSignup=false");
  };
  
    return (
      <aside className="sidebar-api">
        <div className="sidebar-content">
          <div>
          <div className="sidebar-header">
            <div className="sidebar-logo">
              <img src="stockarchiveslogo2.png" alt="stock archive logo" />
            </div>
            <div className="sidebar-title">
              <span>Stock Archives API</span>
              <span className="docs-text">DOCS.</span>
            </div>
          </div>
          <ul className="sidebar-list">
            {sections.map((section,parentIndex) => (
              <div>
                  <li key={section.id} className="sidebar-item">
                    {hideHeaders[parentIndex]?<FaAngleRight />:<FaAngleDown />}

                    <button
                      onClick={() => handleScrollParent(section.id,parentIndex)}
                      className="sidebar-button-section-header-api"
                    >
                      {section.title}
                    </button>
                  </li>
                  <div>
                    {
                      !hideHeaders[parentIndex] && Array.isArray(section.content) && (
                        <div>
                            {section.content.map((subheader, childIndex) =>(
                            <li key={subheader.id} className="sidebar-item-sub">
                              <button
                                onClick={() => handleScroll(subheader.id, childIndex, parentIndex)}
                                className={headerSelected[parentIndex][childIndex]?"sidebar-button-api-active":"sidebar-button-api"}
                              >
                                # {subheader.title}
                              </button>
                            </li>
                          ))
                          }
                        </div>
                      )
                    }
                  </div>
              </div>
            ))}
          </ul>
          </div>
          <button onClick={handleLogout} className="logout-button-api">
            Logout
          </button>
        </div>
    </aside>
    );
  };
  
  export default Sidebar;